export default {
    BASE_URL: '/sob/finance/statistics',
    api: [
      {
        name: 'collectList',
        path: '/collectList',
        method: 'POST',
        desc: '汇总统计 - 列表'
      },
      {
        name: 'exportCollectList',
        path: '/exportCollectList',
        method: 'POST',
        desc: '汇总统计 - 导出'
      },
    ]
  }



// WEBPACK FOOTER //
// ./src/api/apis/self/statistics/collect.js